<template>
<div>
    
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                    <div class="row breadcrumbs-top">
                    <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" >Entry & Loading Control </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to='/entry/daily-transaction'>Entry</router-link>
                                </li>
                                <li class="breadcrumb-item">Dock Control
                                </li>
                            </ol>
                        </div>
                      
                    </div>
                    </div>
                </div>
            
            </div>
          
            <div class="content-body">
               <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <section>
                     <div class="card">
                        <div class="card-header bg-white border-bottom_eee pt-1 px-1 mb-0 common_top_title_searchbgst_dock">
                            <div class="w-auto px-0 mobile-padding-0-2">
                                <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                    <div class="avatar-content">
                                        <em class="lab la-docker i_icon_st font-medium-5"></em>
                                    </div>
                                </div>
                                
                                <h4 class="card-title d-inline-flex ml-0 mb-0">Dock Control</h4>
                                
                            </div>
                            <div class="custom-control custom-switch custom-switch-primary">
                                <span> Flash ON</span>
                                <span class="inoutmargin-5"> 
                                    <input type="checkbox" class="custom-control-input" id="customSwitch14" v-model="torch" checked />
                                    <label class="custom-control-label" for="customSwitch14">
                                        <span class="switch-icon-left"><i data-feather='check'></i></span>
                                        <span class="switch-icon-right"><i data-feather="x"></i></span>
                                    </label>
                                </span>
                                <span> OFF</span>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-0 mobileview_b_8 mobileview_b_px00">
                                <!-- <label class="form-label">Select Camera<span class="requiredField">*</span></label> -->
                                <treeselect placeholder="Select Camera" v-model="camera" :options="camera_options" @input="handleCameraSelection"/>
                            </div>
                        </div>
                        <div class=" col-lg-12">
                            <div class="card text-center mb-1">
                                <div class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0">
                                    <div class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both px-0 w-100">
                                        <nav class="nav-tabs-wrapper">
                                        <ul class="nav nav-pills nav-pill-primary pt-1 nav-tabs-items dragscroll">
                                            <li class="nav-item tabs-item">
                                                <a class="nav-link active" id="dock_vehicle_allocation_form_tab" data-toggle="tab" href="#dock_vehicle_allocation_form" aria-expanded="false"> Dock Vehicle Allocation</a>
                                            </li>
                                            <li class="nav-item tabs-item">
                                                <a class="nav-link" id="doc_in_tab" data-toggle="tab" href="#doc_in" aria-expanded="true">Dock In</a>
                                            </li>
                                            <li class="nav-item tabs-item">
                                                <a class="nav-link" id="seal_break_tab" data-toggle="tab" href="#seal_break" aria-expanded="true">Seal Break</a>
                                            </li>
                                            <li class="nav-item tabs-item" @click="getPalletScanInfo">
                                                <a class="nav-link" id="pallet_scan_tab" data-toggle="tab" href="#pallet_scan" aria-expanded="true">Vehicle Unloading</a>
                                            </li>
<!--                                             <li class="nav-item tabs-item">
                                                <a class="nav-link" id="pallet_to_location_tab" data-toggle="tab" href="#pallet_to_location" aria-expanded="true">Pallet To Location</a>
                                            </li> -->
                                            <li class="nav-item tabs-item" >
                                                <a class="nav-link" id="pallet_move_tab" data-toggle="tab" href="#pallet_move" aria-expanded="true">Pallet Movement</a>
                                            </li>
                                            <li class="nav-item tabs-item" @click="palletUnload">
                                                <a class="nav-link" id="pallet_unload_tab" data-toggle="tab" href="#pallet_unload" aria-expanded="true">Vehicle Loading</a>
                                            </li>
                                            <li class="nav-item tabs-item">
                                                <a class="nav-link" id="doc_out_tab" data-toggle="tab" href="#doc_out" aria-expanded="true">Dock Out</a>
                                            </li>
                                            <li class="nav-item tabs-item">
                                                <a class="nav-link" id="pallet_merge_tab" data-toggle="tab" href="#pallet_merge" aria-expanded="true">Pallet Merge</a>
                                            </li>
                                            <li class="nav-item tabs-item">
                                                <a class="nav-link" id="pallet_location_update_tab" data-toggle="tab" href="#pallet_location_update" aria-expanded="true">Pallet Location Update</a>
                                            </li>
                                            <!-- <li class="nav-item tabs-item" >
                                                <a class="nav-link" id="shipmentBooking_tab" data-toggle="tab" href="#shipmentBooking" aria-expanded="false">Shipment Booking Master</a>
                                            </li> -->
                                            
                                        </ul>
                                    </nav>
                                </div>
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane" id="doc_in" aria-labelledby="doc_in_tab" aria-expanded="true">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Dock No</label>
                                                    <treeselect placeholder="Select Dock No." v-model="formData.dock_in.dock_id"  :options="allocationDoneDockList" @input="handleDockInDockChange" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.dock_in.dock_id">
                                                            Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Vehicle No</label>
                                                    <treeselect placeholder="Select Vehicle No." v-model="formData.dock_in.vehicle_id"   :options="dockWiseAllocationDoneVehicleList" @select="getSealNumbersOfVehicle" @input="clearSealNumbers"/>
                                                    <div class="errorinputmsg text-left" v-if="!formData.dock_in.vehicle_id">
                                                            Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">
                                                      <div class="demo-inline-spacing">
                                                      <div class="form-check form-check-inline">
                                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="loading" value="loading" v-model="formData.dock_in.loading_type"/>
                                                      <label class="form-check-label" for="loading">Loading</label>
                                                      </div>
                                                      <div class="form-check form-check-inline">
                                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="unloading" value="unloading" v-model="formData.dock_in.loading_type" checked />
                                                      <label class="form-check-label" for="unloading">Un Loading</label>
                                                      </div>
                                                      </div>
                                                    </label>
                                                </div>
                                                <template v-if="!dock_in_is_seal_optional" v-for="(seal, idx) in formData.dock_in.seal_scan_no">
                                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Seal scan No {{idx + 1}} ({{seal}})</label>
                                                    <div v-if="idx === 0">
                                                        <div class="d-flex plate_photoscan">
                                                            <input class="form-control" v-model="formData.dock_in.seal_scan_no_0" type="text" placeholder="Enter Seal scan No. "/>
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="!formData.dock_in.seal_scan_no_0">
                                                            Required field
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="formData.dock_in.seal_scan_no_0 && seal !== formData.dock_in.seal_scan_no_0">
                                                            Seal Number must match
                                                        </div>
                                                    </div>
                                                    <div v-else-if="idx === 1">
                                                        <div class="d-flex plate_photoscan">
                                                            <input class="form-control" v-model="formData.dock_in.seal_scan_no_1" type="text" placeholder="Enter Seal scan No. "/>
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="!formData.dock_in.seal_scan_no_1">
                                                            Required field
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="formData.dock_in.seal_scan_no_1 && seal !== formData.dock_in.seal_scan_no_1">
                                                            Seal Number must match
                                                        </div>
                                                    </div>
                                                    <div v-else-if="idx === 2">
                                                        <div class="d-flex plate_photoscan">
                                                            <input class="form-control" v-model="formData.dock_in.seal_scan_no_2" type="text" placeholder="Enter Seal scan No. "/>
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="!formData.dock_in.seal_scan_no_2">
                                                            Required field
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="formData.dock_in.seal_scan_no_2 && seal !== formData.dock_in.seal_scan_no_2">
                                                            Seal Number must match
                                                        </div>
                                                    </div>
                                                    <div v-else-if="idx === 3">
                                                        <div class="d-flex plate_photoscan">
                                                            <input class="form-control" v-model="formData.dock_in.seal_scan_no_3" type="text" placeholder="Enter Seal scan No. "/>
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="!formData.dock_in.seal_scan_no_3">
                                                            Required field
                                                        </div>
                                                        <div class="errorinputmsg text-left" v-if="formData.dock_in.seal_scan_no_3 && seal !== formData.dock_in.seal_scan_no_3">
                                                            Seal Number must match
                                                        </div>
                                                    </div>
                                                </div>
                                                </template>
                                                <div v-if="!dock_in_is_seal_optional" class="col-12 col-sm-6 col-md-6 col-lg-4">
                                                    <label for="is_seal_verified" >Is Seal Verified?</label>
                                                    <input class="mt-1 ml-1" type="checkbox" id="is_seal_verified" v-model="formData.dock_in.is_seal_verified"  />
                                                </div>
                                                <div class="pull-right text-right col-md-12 col-sm-12 col-xs-12  mb-2 common_trs_buttons_res">
                                                    <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('dock_in')" @click="saveData('dock_in')">Submit</button> 
                                                </div>
                                            </div>
                                        </div>
                                        <div role="tabpanel" class="tab-pane" id="seal_break" aria-labelledby="seal_break_tab" aria-expanded="true">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Dock No. <span class="requiredField">*</span></label>
                                                    <treeselect placeholder="Select Dock No." v-model="formData.seal_break.dock_id"  :options="sealBreakDockList" @input="handleSealBreakDockChange" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.seal_break.dock_id">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Vehicle No <span class="requiredField">*</span></label>
                                                    <treeselect placeholder="Select Vehicle No." v-model="formData.seal_break.vehicle_id"   :options="sealBreakVehicleListDockWise" @select="getSealBreakNumbersOfVehicle" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.seal_break.vehicle_id">
                                                            Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5">
                                                    <label class="form-label">Seal Break Photo <span class="requiredField">*</span></label>
                                                    <div class="col-sm-12  plate_photoscan_mobile_canvasimage platesecondphoto">
                                                        <img alt=""  class="round img-fluid" src="../../public/images/icons/camera4.png">
                                                        <canvas id="seal_break-canvas" class="c" width=350 height=350></canvas>
                                                    </div>
                                                    <div class="col-sm-6 plate_photoscan_mobile">
                                                        <video id="seal_break-video" class="overlay-camera" autoplay @click="capturePhoto('seal_break')"></video>
                                                    </div>
                                                    <div class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0">
                                                        <div class="row mx-0">
                                                            <div class="col-10 col-sm-10 px-0">
                                                                <treeselect placeholder="Seal Numbers will appear here" multiple v-model="formData.seal_break.seal_scan_no_value"  :options="formData.seal_break.seal_scan_no" disabled/>
                                                            </div>
                                                            <div class="col-2 col-sm-2 px-0 text-right">
                                                                <button class="gateentyscan_camera_icon"  @click="turnOnCamera('seal_break')">
                                                                   <em class="las la-camera feather-camera"></em>
                                                                </button>
                                                                <audio id="seal_break-sound" :src="photoCaptureSound"></audio>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pull-right text-right col-md-12 col-sm-12 col-xs-12  mb-2 common_trs_buttons_res">
                                                    <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('seal_break')" @click="saveData('seal_break')">Submit</button> 
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div role="tabpanel" class="tab-pane" id="doc_out" aria-labelledby="doc_out_tab" aria-expanded="true">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Dock No</label>
                                                    <treeselect placeholder="Select Dock No." v-model="formData.dock_out.dock_id"  :options="dockEntryDoneDockList" @input="handleDockOutDockChange" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.dock_out.dock_id">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Vehicle No</label>
                                                    <treeselect placeholder="Select Vehicle No." v-model="formData.dock_out.vehicle_id"   :options="dockWiseDockedInVehicleList" @input="handleVehicleChange"/>
                                                    <div class="errorinputmsg text-left" v-if="!formData.dock_out.vehicle_id">
                                                        Required field
                                                    </div>
                                                    <div class="errorinputmsg text-left" v-if="formData.dock_out.vehicle_id">
                                                        <label for="should_vehicle_be_parked" >Should vehicle be parked?</label>
                                                        <input :disabled="was_vehicle_parked" class="mt-1 ml-1" type="checkbox" id="should_vehicle_be_parked" v-model="formData.dock_out.should_vehicle_be_parked" @change="handleShouldVehicleBeParkedChange" />
                                                    </div>
                                                </div>
                                                <div v-if="!dock_out_is_seal_optional" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Total Number of seals <span class="requiredField">*</span></label>
                                                    <treeselect :clearable="false" clear="false" placeholder="Select Vehicle No" v-model="sealNumberCount" :options="sealNumberList" />
                                                </div>
                                                <template v-if="!dock_out_is_seal_optional" v-for="(data, idx) in Array(sealNumberCount).fill(0)">
                                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                        <label class="form-label text-left w-100">Seal Scan No. {{idx+1}}</label>
                                                        <div v-if="idx === 0">
                                                            <div class="d-flex plate_photoscan">
                                                                <input class="form-control" v-model="formData.dock_out.seal_scan_no_0" type="text" placeholder="Enter Seal scan No. "/>
                                                            </div>
                                                            <div class="errorinputmsg text-left" v-if="!formData.dock_out.seal_scan_no_0">
                                                                Required field
                                                            </div>
                                                        </div>
                                                        <div v-else-if="idx === 1">
                                                            <div class="d-flex plate_photoscan">
                                                                <input class="form-control" v-model="formData.dock_out.seal_scan_no_1" type="text" placeholder="Enter Seal scan No. "/>
                                                            </div>
                                                            <div class="errorinputmsg text-left" v-if="!formData.dock_out.seal_scan_no_1">
                                                                Required field
                                                            </div>
                                                        </div>
                                                        <div v-else-if="idx === 2">
                                                            <div class="d-flex plate_photoscan">
                                                                <input class="form-control" v-model="formData.dock_out.seal_scan_no_2" type="text" placeholder="Enter Seal scan No. "/>
                                                            </div>
                                                            <div class="errorinputmsg text-left" v-if="!formData.dock_out.seal_scan_no_2">
                                                                Required field
                                                            </div>
                                                        </div>
                                                        <div v-else-if="idx === 3">
                                                            <div class="d-flex plate_photoscan">
                                                                <input class="form-control" v-model="formData.dock_out.seal_scan_no_3" type="text" placeholder="Enter Seal scan No. "/>
                                                            </div>
                                                            <div class="errorinputmsg text-left" v-if="!formData.dock_out.seal_scan_no_3">
                                                                Required field
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div class="pull-right text-right col-md-12 col-sm-12 col-xs-12  mb-2 common_trs_buttons_res">
                                                    <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('dock_out')" @click="saveData('dock_out')">Submit</button> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="pallet_scan" role="tabpanel" aria-labelledby="pallet_scan_tab" aria-expanded="false">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Vehicle No <span class="requiredField">*</span></label>
                                                    <treeselect placeholder="Select Unloading Vehicle No" v-model="formData.pallet_scan.vehicle_id"  :options="palletScanVehicleList" @input="selectVehicle" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.pallet_scan.vehicle_id">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div v-if="formData.pallet_scan.vehicle_id" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="no_of_packages" class="form-label text-left w-100">No. of packages<span class="requiredField">*</span></label>
                                                    <input id="no_of_packages" :disabled="true" class="form-control" v-model="formData.pallet_scan.no_of_packages" type="text" />
                                                </div>
                                                <div v-if="formData.pallet_scan.vehicle_id" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="no_of_packages" class="form-label text-left w-100">No. of packages scanned<span class="requiredField">*</span></label>
                                                    <input id="no_of_packages" :disabled="true" class="form-control" v-model="formData.pallet_scan.no_of_packages_scanned" type="text" />
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanAWB" class="form-label text-left w-100">Package Number <span class="requiredField">*</span></label>
                                                    <input id="scanAWB" v-on:keyup.enter="scanAWB" class="form-control" v-model="formData.pallet_scan.shipment_awb" type="text" placeholder="Enter Package Number / AWB"/>
                                                    <!-- <treeselect placeholder="Select Shipment AWB" v-model="formData.pallet_scan.shipment_awb"  :options="palletScanAwbList" @input="handleAwbChange" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.pallet_scan.shipment_awb">
                                                        Required field
                                                    </div> -->
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Dock <span class="requiredField">*</span></label>
                                                    <treeselect placeholder="Suggested Dock Number will appear here" v-model="formData.pallet_scan.dock_id"  :options="palletDockList" :clearable="false" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.pallet_scan.dock_id">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanPallet" class="form-label text-left w-100">Pallet <span class="requiredField">*</span> {{palletList.length ? "Suggested Pallet: " + palletList[0].pallet_code : ""}}</label>
                                                    <!-- <treeselect placeholder="Suggested Pallets will appear here" v-model="formData.pallet_scan.pallet_code"  :options="palletList" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.pallet_scan.pallet_code">
                                                        Required field
                                                    </div> -->
                                                    <input id="scanPallet" v-on:keyup.enter="scanPallet" class="form-control" v-model="formData.pallet_scan.pallet_code" type="text" placeholder="Enter Pallet"/>
                                                </div>
                                                <!-- <div class="pull-right d-flex justify-content-end align-items-end text-right col-12 col-sm-12 col-md-12 col-lg-12 mb-1 common_trs_buttons_res">
                                                   <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('pallet_scan')" @click="saveData('pallet_scan')">InScan</button> 
                                                </div> -->
                                               
                                            </div>
                                        </div>
                                        <div role="tabpanel" class="tab-pane" id="pallet_to_location" aria-labelledby="pallet_to_location_tab" aria-expanded="true">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanPalletToLocation" class="form-label text-left w-100">Pallet Code <span class="requiredField">*</span></label>
                                                    <input id="scanPalletToLocation" v-on:keyup.enter="scanPalletToLocation" class="form-control" v-model="formData.pallet_to_location.pallet_code" type="text" placeholder="Enter Pallet Code"/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanLocation" class="form-label text-left w-100">Location Code <span class="requiredField">*</span></label>
                                                    <input id="scanLocation" v-on:keyup.enter="scanLocation" class="form-control" v-model="formData.pallet_to_location.location_code" type="text" placeholder="Enter Location Code"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="pallet_move" role="tabpanel" aria-labelledby="pallet_move_tab" aria-expanded="false">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanPalletToTargetLocation" class="form-label text-left w-100">Pallet Code <span class="requiredField">*</span></label>
                                                    <input id="scanPalletToTargetLocation" v-on:keyup.enter="scanPalletToTargetLocation" class="form-control" v-model="formData.pallet_move.pallet_code" type="text" placeholder="Enter Pallet Code"/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanTargetLocation" class="form-label text-left w-100">Location Code <span class="requiredField">*</span></label>
                                                    <input id="scanTargetLocation" v-on:keyup.enter="scanTargetLocation" class="form-control" v-model="formData.pallet_move.location_code" type="text" placeholder="Enter Location Code"/>
                                                </div>
                                            </div>
                                            <div class="container px-0">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th> Source Dock </th>
                                                                <th> Target Dock </th>
                                                                <th> Sector </th>
                                                                <th> No. of packages </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td> {{formData.pallet_move.source_dock_name}}</td>
                                                                <td> {{formData.pallet_move.target_dock_name}}</td>
                                                                <td> {{formData.pallet_move.sector}}</td>
                                                                <td> {{formData.pallet_move.no_of_packages}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <!-- <div class="table-responsive datatableview">
                                                <table class="table table-hover table_stickys  table-striped table-col-td-white custom_doctable ">
                                                    <thead>
                                                        <tr>
                                                            <th  class="text-left align-middle">Pallet Code</th>
                                                            <th  class="text-left align-middle">Source Dock</th>
                                                            <th  class="text-left align-middle">Target Dock</th>    
                                                            <th  class="text-left align-middle">No. of packages</th>           
                                                            <th  class="text-left align-middle">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(data,index) in palletMovementList"  >
                                                            <tr>
                                                                <td data-column="Pallet Code"  class="text-left">{{data.pallet_code}}</td>
                                                                <td data-column="Source Dock" class="text-left">{{data.source_dock_name}}</td>
                                                                <td data-column="Target Dock" class="text-left">{{data.target_dock_name}} </td>

                                                                <td data-column="No. of packages" class="text-left">{{data.no_of_packages}} </td>                              
                                                                <td class="text-left">
                                                                    <div class="d-flex align-items-end text-right col-12 col-sm-12 col-md-12 col-lg-12">
                                                                       <button v-if="data.is_moved === 1" type="button" class="btn btn-outline-primary common-btn_btn_view" :disabled="data.is_moved === 1" @click="movePallet(data)" style="cursor: blocked">Moved</button> 
                                                                       <button v-else type="button" class="btn btn-outline-primary common-btn_btn_view"  @click="movePallet(data)" >Move</button> 
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <template v-if="!palletMovementList.length">
                                                            <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div> -->
                                            
                                        </div>
                                        <div class="tab-pane" id="pallet_unload" role="tabpanel" aria-labelledby="pallet_unload_tab" aria-expanded="false">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Vehicle No. <span class="requiredField">*</span></label>
                                                    <treeselect placeholder="Select Unloading Vehicle No." v-model="formData.pallet_unload.vehicle_id"  :options="palletScanLoadVehicleList" @input="selectLoadVehicle" />
                                                    <!-- <div class="errorinputmsg text-left" v-if="!formData.pallet_unload.vehicle_id">
                                                        Required field
                                                    </div> -->
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanPalletUnload" class="form-label text-left w-100">Pallet Code <span class="requiredField">*</span></label>
                                                    <input id="scanPalletUnload" v-on:keyup.enter="scanPalletUnload" class="form-control" v-model="formData.pallet_unload.pallet_code" type="text" placeholder="Enter Pallet Code"/>
                                                </div>
                                                <div v-if="formData.pallet_unload.no_of_packages" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="no_of_packages" class="form-label text-left w-100">No. of packages<span class="requiredField">*</span></label>
                                                    <input id="no_of_packages" :disabled="true" class="form-control" v-model="formData.pallet_unload.no_of_packages" type="text" />
                                                </div>
                                                <div v-if="formData.pallet_unload.no_of_packages" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="no_of_packages" class="form-label text-left w-100">No. of packages scanned<span class="requiredField">*</span></label>
                                                    <input id="no_of_packages" :disabled="true" class="form-control" v-model="formData.pallet_unload.no_of_packages_scanned" type="text" />
                                                </div>
                                                <div v-if="formData.pallet_unload.no_of_packages" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanPalletUnloadAWB" class="form-label text-left w-100">Package Number {{formData.pallet_unload.no_of_packages_scanned+1}}<span class="requiredField">*</span></label>
                                                    <input id="scanPalletUnloadAWB" v-on:keyup.enter="scanPalletUnloadAWB" class="form-control" v-model="formData.pallet_unload.shipment_awb" type="text" placeholder="Enter Package Number / AWB"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="shipmentBooking" role="tabpanel" aria-labelledby="shipmentBooking_tab" aria-expanded="false">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Package Number</label>
                                                    <input class="form-control" type="text" placeholder="Enter Package Number / AWB "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Booking Center</label>
                                                    <input class="form-control" type="text" placeholder="Enter Booking Center "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Actual Weight</label>
                                                    <input class="form-control" type="text" placeholder="Enter Shipment Actual Weight "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Volumetric Weight</label>
                                                    <input class="form-control" type="text" placeholder="Enter Shipment Volumetric Weight "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Dimensions</label>
                                                    <input class="form-control" type="text" placeholder="Enter Shipment Dimensions "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Category</label>
                                                    <treeselect placeholder="Select Shipment Category"   :options="statuslist" @input="selectstatus" />
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Sub Type</label>
                                                    <treeselect placeholder="Select Shipment Sub Type"   :options="statuslist" @input="selectstatus" />
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Charges</label>
                                                    <input class="form-control" type="text" placeholder="Enter charges "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Tax</label>
                                                    <input class="form-control" type="text" placeholder="Enter charges "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Delivery Address</label>
                                                    <textarea class="form-control" id="#" rows="3" placeholder="Enter Delivery Address"></textarea>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">City</label>
                                                    <treeselect placeholder="Select Shipment Sub Type"   :options="statuslist" @input="selectstatus" />
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100"> Delivery Pincode</label>
                                                    <input class="form-control" type="text" placeholder="Enter Delivery Pincode "/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Delivery State</label>
                                                    <treeselect placeholder="Select Delivery State"   :options="statuslist" @input="selectstatus" />
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Route Type</label>
                                                    <treeselect placeholder="Select Route Type"   :options="statuslist" @input="selectstatus" />
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Express Route </label>
                                                    <treeselect placeholder="Select Express Route"   :options="statuslist" @input="selectstatus" />
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Feeder Route </label>
                                                    <treeselect placeholder="Select Feeder Route"   :options="statuslist" @input="selectstatus" />
                                                </div>
                                                <div class="pull-right text-right col-12 col-md-6 col-sm-6 col-lg-8  mb-2 common_trs_buttons_res">
                                                    <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('shipment_booking_master')" @click="saveData('shipment_booking_master')">Submit</button> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane active" id="dock_vehicle_allocation_form" role="tabpanel" aria-labelledby="dock_vehicle_allocation_form_tab" aria-expanded="false">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Dock No <span class="requiredField">*</span></label>
                                                    <treeselect placeholder="Select Available Dock No"  v-model="formData.dock_vehicle_allocation.dock_id" :options="available_dockList" @input="selectstatus" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.dock_vehicle_allocation.dock_id">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Vehicle No. <span class="requiredField">*</span></label>
                                                    <treeselect placeholder="Select Vehicle No." v-model="formData.dock_vehicle_allocation.vehicle_id"  :options="vehicleList" />
                                                    <div class="errorinputmsg text-left" v-if="!formData.dock_vehicle_allocation.vehicle_id">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 expected_Datevieww100">
                                                    <label for="expected_duration" class="form-label text-left w-100">Targeted Duration</label>
                                                    <vue-timepicker name="expected_duration" class="appmdldesc_input-100 " type="time" id="qahours" format="HH:mm"  v-model="formData.dock_vehicle_allocation.expected_duration" :minute-interval="10" :hour-range="[[0,23]]"></vue-timepicker>
                                                    <div class="errorinputmsg text-left" v-if="!formData.dock_vehicle_allocation.expected_duration">
                                                        Required field
                                                    </div>
                                                    <div class="errorinputmsg text-left" v-if="formData.dock_vehicle_allocation.expected_duration && (!formData.dock_vehicle_allocation.expected_duration.HH || !formData.dock_vehicle_allocation.expected_duration.mm)">
                                                        Invalid format
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <!-- <label for="scannedCode" class="form-label text-left w-100">Barcode Scan</label>
                                                    <input class="form-control mb-1" type="text" id="scannedCode" placeholder="Code will appear here or can be entered manually " v-model="scannedCode"/> -->
                                                    <!-- <div class=" plate_photoscan">
                                                        <div id="videoWindow" class="video barcodescanner_master">
                                                            <video id="cameraFeedContainer"></video>
                                                            <canvas class="drawingBuffer"></canvas>
                                                        </div>
                                                        <audio id="sound1"  :src="beepSound">
                                                        </audio>
                                                        <div class="common_trs_buttons_resbarcode text-right">
                                                            <button v-show="!scannerActive" class="btn btn-relief-secondary level-item mt-0">
                                                                <a @click="startScanner" class="button">Start Scanner</a>
                                                            </button>

                                                            <button v-show="scannerActive" class="btn btn-relief-secondary  level-item mt-0">
                                                                <a @click="stop" class="button">Stop Scanner</a>
                                                            </button>
                                                        </div>
                                                       </div>
                                                       -->
                                                    </div>
                                                    <div class="pull-right d-flex justify-content-end align-items-end text-right col-12 col-sm-12 col-md-12 col-lg-12 mb-1 common_trs_buttons_res">
                                                   
                                                   <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('dock_vehicle_allocation')" @click="saveData('dock_vehicle_allocation')">Submit</button> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="pallet_merge" role="tabpanel" aria-labelledby="pallet_merge_tab" aria-expanded="false">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanSourcePallet1" class="form-label text-left w-100">Source Pallet 1<span class="requiredField">*</span></label>
                                                    <input id="scanSourcePallet1" v-on:keyup.enter="scanSourcePallet" class="form-control" v-model="formData.pallet_merge.source_pallet_code_1" type="text" placeholder="Enter Pallet Code"/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanSourcePallet2" class="form-label text-left w-100">Source Pallet 2<span class="requiredField">*</span></label>
                                                    <input id="scanSourcePallet2" v-on:keyup.enter="scanSourcePallet2" class="form-control" v-model="formData.pallet_merge.source_pallet_code_2" type="text" placeholder="Enter Pallet Code"/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1" >
                                                    <label for="targetPallet" class="form-label text-left w-100">Target Pallet <span class="requiredField">*</span></label>
                                                    <input id="targetPallet" v-on:keyup.enter="scanMergedPallet" class="form-control" v-model="formData.pallet_merge.merged_pallet_code" type="text" placeholder="Enter Pallet Code"/>
                                                </div>
                                                <div class="container px-0">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th rowspan="2">Dock / Sector</th>
                                                                <th > Source Pallet 1</th>
                                                                <th > Source Pallet 2</th>
                                                                <th > Target Pallet </th>
                                                            </tr>
                                                            <tr>
                                                                <th> No. of packages </th>
                                                                <th> No. of packages </th>
                                                                <th> Merged No. of packages </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td> {{formData.pallet_merge.target_dock_name}} / {{formData.pallet_merge.sector}}</td>
                                                                <td> {{formData.pallet_merge.source_dock_1_no_of_packages}}</td>
                                                                <td> {{formData.pallet_merge.source_dock_2_no_of_packages}}</td>
                                                                <td> {{formData.pallet_merge.merged_no_of_packages}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                                <!-- <div class="pull-right d-flex justify-content-end align-items-end text-right col-12 col-sm-12 col-md-12 col-lg-12 mb-1 common_trs_buttons_res">
                                                   <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('pallet_merge')" @click="saveData('pallet_merge')">InScan</button> 
                                                </div> -->
                                               
                                            </div>
                                        </div>
                                        <div role="tabpanel" class="tab-pane" id="pallet_location_update" aria-labelledby="pallet_location_update_tab" aria-expanded="true">
                                            <div class="row">
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanPalletLocationUpdate" class="form-label text-left w-100">Pallet Code <span class="requiredField">*</span></label>
                                                    <input id="scanPalletLocationUpdate" v-on:keyup.enter="scanPalletLocationUpdate" class="form-control" v-model="formData.pallet_location_update.pallet_code" type="text" placeholder="Enter Pallet Code"/>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label for="scanPalletTargetLocation" class="form-label text-left w-100">Location Code <span class="requiredField">*</span></label>
                                                    <input id="scanPalletTargetLocation" v-on:keyup.enter="scanPalletTargetLocation" class="form-control" v-model="formData.pallet_location_update.target_location_code" type="text" placeholder="Enter Target Location Code"/>
                                                </div>
                                            </div>
                                            <div class="container px-0">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th> Dock </th>
                                                                <th> Sector </th>
                                                                <th> Current Location </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td> {{formData.pallet_location_update.dock_name}}</td>
                                                                <td> {{formData.pallet_location_update.sector}}</td>
                                                                <td> {{formData.pallet_location_update.source_location_code}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                     </div>
                </section>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import Quagga from 'quagga';
import 'vue2-datepicker/index.css'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueElementLoading from 'vue-element-loading'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import searchMasterNameList from "../utils/searchMasterNameList"
import common_methods from "../utils/common_methods"

export default({
    name:'masterCreate',
    mixins: [searchMasterNameList, common_methods],
    data() {
        return {
            codeReader: {},
            isLoading: false,
            torch: false,
            un:'',
            camera_options: [],
            camera: null,
            id: null,
            videoPoster: 'images/icons/camera4.png',
            beepSound: 'sound/store-scanner-beep-90395.wav',
            photoCaptureSound: 'sound/iphone-camera-capture-6448.wav',
            scannedCode: null,
            scannerActive: false,
            sealNumberCount: 1,
            sealNumberList: [{id:1, label:'One'}, {id:2, label:'Two'}, {id:3, label:'Three'}, {id:4, label:'Four'}],
            pagefeatures:[],
            startdate:'',
            statuslist: [],
            dockList: [],
            available_dockList: [],
            vehicleList: [],
            allocationDoneDockList: [],
            allocationDoneVehicleList: [],
            dockWiseAllocationDoneVehicleList: [],
            dockedInVehicleList: [],
            dockWiseDockedInVehicleList: [],
            sealBreakDockList: [],
            sealBreakVehicleList: [],
            sealBreakVehicleListDockWise: [],
            gateEntryPassList: [],
            dockEntryDoneDockList: [],
            palletScanVehicleList: [],
            palletScanAwbList: [],
            palletScanLoadVehicleList: [],
            palletList: [],
            palletDockList: [],
            palletMovementList: [],
            dock_out_is_seal_optional: false,
            dock_in_is_seal_optional: false,
            was_vehicle_parked: false,
            formData: {
                dock_vehicle_allocation: {
                    dock_id: null,
                    vehicle_id: null,
                    gate_entry_id: null,
                    expected_duration: null,
                },
                dock_in: {
                    dock_id: null,
                    vehicle_id: null,
                    seal_scan_no_0: null,
                    seal_scan_no_1: null,
                    seal_scan_no_2: null,
                    seal_scan_no_3: null,
                    seal_scan_no: [],
                    loading_type: "unloading",
                    is_seal_verified: false
                },
                dock_out: {
                    dock_id: null,
                    vehicle_id: null,
                    seal_scan_no_0: null,
                    seal_scan_no_1: null,
                    seal_scan_no_2: null,
                    seal_scan_no_3: null,
                    seal_scan_no: [],
                    should_vehicle_be_parked: false
                },
                shipment_booking_master: {
                    shipment_awb: null,
                    booking_center_id: null,
                    shipment_actual_weight: null,
                    shipment_volumetric_weight: null,
                    shipment_dimensions: null,
                    shipment_category: null,
                    shipment_subtype: null,
                    charges: null,
                    tax: null,
                    delivery_address: null,
                    delivery_city: null,
                    delivery_pincode: null,
                    delivery_state: null,
                    route_type: null,
                    shipment_status: null,
                    shipment_delivery_datetime: null,
                },
                seal_break: {
                    dock_id: null,
                    vehicle_id: null,
                    seal_scan_no_value: null,
                    seal_scan_no: []
                },
                pallet_scan: {
                    vehicle_id: null,
                    pallet_code: null,
                    dock_id: null,
                    shipment_awb: null,
                    no_of_packages: 0,
                    no_of_packages_scanned: 0,
                    scanned_percentage: 0,
                    filledSticks: 0,
                    sector: null,
                },
                pallet_move: {
                    pallet_code: null,
                    source_dock_name: null,
                    target_dock_name: null,
                    gate_entry_id: null,
                    location_code: null,
                    target_dock_id: null,
                    no_of_packages: null,
                    sector: null,
                },
                pallet_unload: {
                    vehicle_id: null,
                    pallet_code: null,
                    no_of_packages: 0,
                    no_of_packages_scanned: 0,
                    shipment_awb: null,
                    gate_entry_id: null
                },
                pallet_to_location: {
                    pallet_code: null,
                    source_dock_id: null,
                    location_code: null
                },
                pallet_merge: {
                    source_pallet_code_1: null,
                    source_pallet_code_2: null,
                    merged_pallet_code: null,
                    target_dock_name: null,
                    target_dock_id: null,
                    source_dock_1_no_of_packages: 0,
                    source_dock_2_no_of_packages: 0,
                    merged_no_of_packages: 0,
                    sector: null,
                },
                pallet_location_update: {
                    pallet_code: null,
                    source_location_code: null,
                    target_location_code: null,
                    target_dock_id: null,
                    dock_name: null,
                    sector: null
                },
            },
            captures: {
                seal_break: {
                    stream: null,
                    file: null,
                },
            },
        }  
    } ,
    components: {
        DatePicker,
        Treeselect,
        Loading,
        VueElementLoading,
        VueTimepicker,
    },
    mounted(){
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        $(window).on('load', function() {
            if (feather) {
                feather.replace({
                    width: 14,
                    height: 14
                });
            }
        })
    },
    created() {
        // this.getDockList()
        this.getCameraSelection()
        this.getAvailableDockList()
        this.getEntryPassDoneVehicleNumberList()
        this.getAllocationDoneDockList()
        this.getAllocationDoneVehicleNumberList()
        /* SEAL BREAK DATA */
        this.getSealBreakDocks()
        this.getSealBreakVehicles()
        /* --- */
        this.getDockedInVehicleNumberList()
        this.getDockEntryDoneDockList()
    },
    methods: {
        scanPalletToLocation() {
            let pallet_code = this.formData.pallet_to_location.pallet_code
            let url = `/shipments/pallet-scan/pallet-movement/${pallet_code}`
            let payload = this.formData.pallet_scan
            this.makeRequest("GET", url)
            .then(result => {
                this.formData.pallet_to_location.source_dock_id = result.data.data[0].source_dock_id
                this.sweetAlertSnackbar(result.data.message)
                document.getElementById("scanLocation").focus()
            })
            .catch(e => {
                this.formData.pallet_to_location.pallet_code = null
                document.getElementById("scanPalletToLocation").focus()
                this.displayError(e)
            })
        },
        scanLocation() {
            let payload = this.formData.pallet_to_location
            let url = `/shipments/pallet-scan/pallet-movement/map-pallet-location`
            this.makeRequest("POST", url, payload)
                .then(result => {
                    this.formData.pallet_to_location.pallet_code = null
                    this.formData.pallet_to_location.source_dock_id = null
                    this.formData.pallet_to_location.location_code = null
                    this.sweetAlertSnackbar(result.data.message, 'success')
                    document.getElementById("scanPalletToLocation").focus()
                })
                .catch(e => {
                    this.formData.pallet_to_location.location_code = null
                    document.getElementById("scanLocation").focus()
                    this.displayError(e)
                })
        },
        scanPalletToTargetLocation() {
            let pallet_code = this.formData.pallet_move.pallet_code
            let url = `/shipments/pallet-scan/pallet-movement/${pallet_code}/move`
            this.makeRequest("GET", url)
            .then(result => {
                let data = result.data.data[0]
                this.formData.pallet_move.target_dock_name = data.target_dock_name
                this.formData.pallet_move.source_dock_name = data.source_dock_name
                this.formData.pallet_move.target_dock_id = data.target_dock_id
                this.formData.pallet_move.gate_entry_id = data.gate_entry_id
                this.formData.pallet_move.no_of_packages = data.no_of_packages
                this.formData.pallet_move.location_code = result.data.location
                this.formData.pallet_move.sector = data.sector
                this.sweetAlertSnackbar(result.data.message)
                document.getElementById("scanTargetLocation").focus()
            })
            .catch(e => {
                this.formData.pallet_move.pallet_code = null
                document.getElementById("scanPalletToTargetLocation").focus()
                this.displayError(e)
            })
        },
        scanTargetLocation() {
            let payload = this.formData.pallet_move
            // let url = `/shipments/pallet-scan/pallet-movement/map-pallet-target-location`
            let url = `/entry/unloading/pallet-movement/${payload.pallet_code}/move`
            this.makeRequest("POST", url, payload)
                .then(result => {
                    this.formData.pallet_move.pallet_code = null
                    this.formData.pallet_move.source_dock_name = null
                    this.formData.pallet_move.target_dock_name = null
                    this.formData.pallet_move.gate_entry_id = null
                    this.formData.pallet_move.location_code = null
                    this.formData.pallet_move.no_of_packages = null
                    this.formData.pallet_move.sector = null
                    this.sweetAlertSnackbar(result.data.message, 'success')
                    document.getElementById("scanPalletToTargetLocation").focus()
                })
                .catch(e => {
                    this.formData.pallet_move.location_code = null
                    document.getElementById("scanTargetLocation").focus()
                    this.displayError(e)
                })
        },
        // movePallet(data) {
        //     console.log(data)
        //     this.isLoading = true
        //     let url = `/entry/unloading/pallet-movement/${data.gate_entry_id}/${data.pallet_code}/move`
        //     this.makeRequest("POST", url)
        //     .then(result => {
        //         this.getPalletMovementList()
        //         this.sweetAlertSnackbar(result.data.message, 'success')
        //     })
        //     .catch(e => {
        //         this.displayError(e)
        //     })
        // },
        getVehicleLabel(id) {
            if(!id) return "--"
            let vehicle = this.palletScanVehicleList.find(v => v.id == id)
            if(vehicle) {
                return vehicle.label
            }
            return "--"
        },
        selectVehicle(id) {
            setTimeout(() => {
                let element = document.getElementById("scanAWB")
                element.focus()
            }, 300)
            if(!id) return
            let url = `/shipments/${this.formData.pallet_scan.vehicle_id}`
            this.makeRequest("GET", url)
                .then(result => {
                    this.formData.pallet_scan.no_of_packages = result.data[0].no_of_packages
                    this.getScannedShipmentCount(id)
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        getScannedShipmentCount(id) {
            let url = `/shipments/${this.formData.pallet_scan.vehicle_id}/scanned`
            this.makeRequest("GET", url)
                .then(result => {
                    this.formData.pallet_scan.no_of_packages_scanned = result.data[0].no_of_packages_scanned
                    if(this.formData.pallet_scan.no_of_packages) {
                        this.formData.pallet_scan.scanned_percentage = this.roundNumber(100 * ( this.formData.pallet_scan.no_of_packages_scanned / this.formData.pallet_scan.no_of_packages ))  
                        let number = Math.floor(this.formData.pallet_scan.scanned_percentage/10)
                        this.formData.pallet_scan.filledSticks = 10 - number
                    }
                    
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        scanAWB() {          
            let vehicle_id = this.formData.pallet_scan.vehicle_id ? this.formData.pallet_scan.vehicle_id : 0 
            let url = `/shipments/validateAWB/${this.formData.pallet_scan.shipment_awb}?vehicle_id=${vehicle_id}`
            this.makeRequest("GET", url)
            .then(result => {
                this.palletList = result.data.data.palletList
                this.palletDockList = result.data.data.dockList
                this.formData.pallet_scan.sector = result.data.data.sector
                if(this.palletDockList?.length) {
                    this.formData.pallet_scan.dock_id = this.palletDockList[0].id
                }
                if(this.palletList?.length) {
                    this.formData.pallet_scan.pallet_code = this.palletList[0].pallet_code
                }
                this.sweetAlertSnackbar(`sector = ${this.formData.pallet_scan.sector}`)
                let element = document.getElementById("scanPallet")
                element.focus()

            })
            .catch(e => {
                this.formData.pallet_scan.dock_id = null
                this.formData.pallet_scan.pallet_code = null
                this.formData.pallet_scan.shipment_awb = null
                this.palletDockList = []
                this.displayError(e)
            })
        },
        scanPallet() {
            let url = `/entry/unloading/pallet-scan/create`
            let payload = this.formData.pallet_scan
            this.makeRequest("POST", url, payload)
            .then(result => {
                this.getScannedShipmentCount()
                this.resetform('pallet_scan')
                this.palletList = []
                this.palletDockList = []
                this.sweetAlertSnackbar(result.data.message, 'success')
                document.getElementById("scanAWB").focus()
            })
            .catch(e => {
                let response = e ? e.response : e
                if(response?.data?.code === 'INVALID_PALLET') {
                    this.formData.pallet_scan.pallet_code = null
                    document.getElementById("scanPallet").focus()
                } else {
                    this.formData.pallet_scan.dock_id = null
                    this.formData.pallet_scan.shipment_awb = null
                    this.palletDockList = []
                    this.formData.pallet_scan.pallet_code = null
                    document.getElementById("scanAWB").focus()
                }

                this.displayError(e)
            })
        },
        selectLoadVehicle(id) {
            setTimeout(() => {
                let element = document.getElementById("scanPalletUnload")
                element.focus()
            }, 300)
            let vehicleDetails = this.palletScanLoadVehicleList.find(vehicle => vehicle.id == id)
            if(vehicleDetails) {
                this.formData.pallet_unload.gate_entry_id = vehicleDetails.gate_entry_id
            } else {
                this.formData.pallet_unload.gate_entry_id = null
            }
        },
        palletUnload() {
            this.getVehiclesForPalletUnloadScan()
            let element = document.getElementById("scanPalletUnload")
            element.focus()
        },
        scanPalletUnload() {
            let pallet_code = this.formData.pallet_unload.pallet_code
            let url = `/shipments/pallet-scan/${pallet_code}/unload`
            this.makeRequest("GET", url)
                .then(result => {
                    let data = result.data.data
                    this.formData.pallet_unload.no_of_packages = data.result[0].no_of_packages
                    this.formData.pallet_unload.no_of_packages_scanned = data.packages.reduce((a, c) => {
                        if(c.is_unloaded) {
                            a += 1
                        }
                        return a
                    }, 0)
                    setTimeout(() => {
                        let element = document.getElementById("scanPalletUnloadAWB")
                        element.focus()
                    }, 300)
                    
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        scanPalletUnloadAWB() {
            let shipment_awb = this.formData.pallet_unload.shipment_awb
            let pallet_code = this.formData.pallet_unload.pallet_code
            let url = `/shipments/pallet-scan/${pallet_code}/awb-scan/${shipment_awb}/unload?vehicle_id=${this.formData.pallet_unload.vehicle_id}&gate_entry_id=${this.formData.pallet_unload.gate_entry_id}`
            this.makeRequest("GET", url)
                .then(result => {
                    this.formData.pallet_unload.no_of_packages_scanned = this.formData.pallet_unload.no_of_packages_scanned+1
                    this.formData.pallet_unload.shipment_awb = null
                    let message = result.data.message
                    if(this.formData.pallet_unload.no_of_packages_scanned === this.formData.pallet_unload.no_of_packages) {
                        message += " All packaged scanning done!"
                        this.formData.pallet_unload.pallet_code = null
                        this.formData.pallet_unload.no_of_packages = 0
                        this.formData.pallet_unload.no_of_packages_scanned = 0
                        // this.makeRequest("GET", )
                        let element = document.getElementById("scanPalletUnload")
                        element.focus()
                    }
                    this.sweetAlertSnackbar(message, 'success')
                    let data = result.data.data
                    
                })
                .catch(e => {
                    this.formData.pallet_unload.shipment_awb = null
                    this.displayError(e)
                })
        },
        scanSourcePallet() {
            let url = `/shipments/pallet-scan/pallet-merge/${this.formData.pallet_merge.source_pallet_code_1}`
            this.makeRequest("GET", url)
                .then(result => {
                    let data = result.data.data
                    this.formData.pallet_merge.target_dock_name = data.dock_name
                    this.formData.pallet_merge.target_dock_id = data.target_dock_id
                    this.formData.pallet_merge.sector = data.sector
                    this.formData.pallet_merge.source_dock_1_no_of_packages = data.no_of_packages
                    if(this.formData.pallet_merge.source_pallet_code_1 === this.formData.pallet_merge.source_pallet_code_2) {
                        this.formData.pallet_merge.merged_no_of_packages = this.formData.pallet_merge.source_dock_1_no_of_packages
                    } else {
                        this.formData.pallet_merge.merged_no_of_packages = this.formData.pallet_merge.source_dock_1_no_of_packages + this.formData.pallet_merge.source_dock_2_no_of_packages
                    }
                    this.sweetAlertSnackbar(`${result.data.message}`)
                    document.getElementById("scanSourcePallet2").focus()
                })
                .catch(e => {
                    this.formData.pallet_merge.source_pallet_code_1 = null
                    this.displayError(e)
                })
        },
        scanSourcePallet2() {
            if(!this.formData.pallet_merge.target_dock_id || !this.formData.pallet_merge.source_pallet_code_1) {
                this.formData.pallet_merge.source_pallet_code_2 = null
                this.sweetAlertSnackbar("Please scan source pallet 1 first", "error")
                return
            }
            if(!this.formData.pallet_merge.source_pallet_code_2) {
                this.formData.pallet_merge.source_pallet_code_2 = null
                this.sweetAlertSnackbar("Please scan source pallet 2 properly", "error")
                return
            }
            let url = `/shipments/pallet-scan/pallet-merge/source`
            this.makeRequest("POST", url, { 
                pallet_code: this.formData.pallet_merge.source_pallet_code_2,
                target_dock_id: this.formData.pallet_merge.target_dock_id,
                sector: this.formData.pallet_merge.sector
            })
                .then(result => {
                    let data = result.data.data
                    this.formData.pallet_merge.source_dock_2_no_of_packages = data.no_of_packages
                    if(this.formData.pallet_merge.source_pallet_code_1 === this.formData.pallet_merge.source_pallet_code_2) {
                        this.formData.pallet_merge.merged_no_of_packages = this.formData.pallet_merge.source_dock_1_no_of_packages
                    } else {
                        this.formData.pallet_merge.merged_no_of_packages = this.formData.pallet_merge.source_dock_1_no_of_packages + this.formData.pallet_merge.source_dock_2_no_of_packages
                    }
                    this.sweetAlertSnackbar(`${result.data.message}`)
                    document.getElementById("targetPallet").focus()
                })
                .catch(e => {
                    this.formData.pallet_merge.source_pallet_code_2 = null
                    this.displayError(e)
                })
        },
        scanMergedPallet() {
            if(!this.formData.pallet_merge.target_dock_id || !this.formData.pallet_merge.source_pallet_code_1 || !this.formData.pallet_merge.source_pallet_code_1) {
                this.formData.pallet_merge.merged_pallet_code = null
                this.sweetAlertSnackbar("Please scan source pallet 1 & 2 first", "error")
                return
            }
            if(!this.formData.pallet_merge.merged_pallet_code) {
                this.formData.pallet_merge.merged_pallet_code = null
                this.sweetAlertSnackbar("Please scan merge pallet", "error")
                return
            }
            if((this.formData.pallet_merge.source_pallet_code_1 === this.formData.pallet_merge.merged_pallet_code) || (this.formData.pallet_merge.source_pallet_code_2 === this.formData.pallet_merge.merged_pallet_code)) {
                this.formData.pallet_merge.merged_pallet_code = null
                this.sweetAlertSnackbar("Merge pallet can not be same as source pallet", "error")
                return
            }
            let url = `/shipments/pallet-scan/pallet-merge/merge`
            this.makeRequest("POST", url, { 
                    source_pallet_code_1:  this.formData.pallet_merge.source_pallet_code_1,
                    source_pallet_code_2:  this.formData.pallet_merge.source_pallet_code_2,
                    pallet_code: this.formData.pallet_merge.merged_pallet_code, 
                    target_dock_id: this.formData.pallet_merge.target_dock_id,
                    sector: this.formData.pallet_merge.sector
                })
                .then(result => {
                    this.sweetAlertSnackbar(`${result.data.message}`)
                    this.formData.pallet_merge.target_dock_name = null
                    this.formData.pallet_merge.target_dock_id = null
                    this.formData.pallet_merge.source_dock_1_no_of_packages = 0
                    this.formData.pallet_merge.source_dock_2_no_of_packages = 0
                    this.formData.pallet_merge.merged_no_of_packages = 0
                    this.formData.pallet_merge.source_pallet_code_1 = null
                    this.formData.pallet_merge.source_pallet_code_2 = null
                    this.formData.pallet_merge.merged_pallet_code = null
                    this.formData.pallet_merge.sector = null
                    document.getElementById("scanSourcePallet1").focus()
                })
                .catch(e => {
                    this.formData.pallet_merge.merged_pallet_code = null
                    this.displayError(e)
                })
        },
        scanPalletLocationUpdate() {
            let url = `/shipments/pallet-scan/${this.formData.pallet_location_update.pallet_code}`
            this.makeRequest("GET", url)
                .then(result => {
                    let data = result.data.data
                    this.formData.pallet_location_update.target_dock_id = data.target_dock_id
                    this.formData.pallet_location_update.sector = data.sector
                    this.formData.pallet_location_update.dock_name = data.dock_name
                    this.formData.pallet_location_update.source_location_code = data.target_location_code
                    this.sweetAlertSnackbar(`${result.data.message}`)
                    document.getElementById("scanPalletTargetLocation").focus()
                })
                .catch(e => {
                    this.formData.pallet_location_update.source_pallet_code_1 = null
                    this.displayError(e)
                })
        },
        scanPalletTargetLocation() {
            if(!this.formData.pallet_location_update.pallet_code || !this.formData.pallet_location_update.target_dock_id || !this.formData.pallet_location_update.sector) {
                this.formData.pallet_location_update.pallet_code = null
                this.sweetAlertSnackbar("Please scan pallet first", "error")
                return
            }
            let payload = this.formData.pallet_location_update
            let url = `/shipments/pallet-scan/pallet-location-update`
            this.makeRequest("POST", url, payload)
                .then(result => {
                    this.formData.pallet_location_update.target_dock_id = null
                    this.formData.pallet_location_update.sector = null
                    this.formData.pallet_location_update.dock_name = null
                    this.formData.pallet_location_update.source_location_code = null
                    this.formData.pallet_location_update.pallet_code = null
                    this.formData.pallet_location_update.target_location_code = null
                    this.sweetAlertSnackbar(result.data.message, 'success')
                    document.getElementById("scanPalletLocationUpdate").focus()
                })
                .catch(e => {
                    this.formData.pallet_to_location.location_code = null
                    document.getElementById("scanPalletTargetLocation").focus()
                    this.displayError(e)
                })
        },
        async capturePhoto(id2, index="") {
            let id = id2 + index
            let canvas = document.querySelector(`#${id}-canvas`);
            let video = document.querySelector(`#${id}-video`);
            canvas.style.display = "block"
            let imgWidth = video.videoWidth ?? canvas.width
            let imgHeight = video.videoHeight ?? canvas.height
            this.width = video.videoWidth
            this.height = video.videoHeight
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            this.PlaySound(`${id}-sound`)
            let stream = video.srcObject
            let tracks = stream.getVideoTracks()
            if(this.torch && tracks.length) {
                const videoTrack = tracks[0];
                await videoTrack.applyConstraints({torch: false});
            }
            video.srcObject = null
            const storeFile = (file) => {
                if(index !== "") {
                    this.captures[id2][`file${index}`] = file
                } else {
                    this.captures[id2].file = file
                }
            }
            document.querySelector(`#${id}-canvas`).toBlob(function(blob) {
                storeFile(new File([blob], `${id}_photo.jpg`, { type: 'image/jpeg' }))
            }, 'image/jpeg');
            if(this.captures[id2].stream) {
                this.captures[id2].stream.getTracks().forEach(function(track) {
                    track.stop();
                });
            }
            video.style.display = "none";
        },
        async turnOnCamera(id2,index="") {
            this.isLoading = true
            // Capture logic here
            let id = id2 + index
            let video = document.getElementById(`${id}-video`)
            video.style.display = "block";
            let videoConstraints = {
                audio: false,
                video: {
                    width: { ideal: 4096 },
                    height: { ideal: 2160 },
                    facingMode: {
                        exact: "environment"
                    }
                }
            }
            if(this.camera) {
                videoConstraints = { video: { facingMode: "user" }, audio: false }
            }
            try {
                let stream = await navigator.mediaDevices.getUserMedia(videoConstraints);
                let tracks = stream.getVideoTracks()
                if(this.torch) {
                    if(tracks.length) {
                        const videoTrack = tracks[0];
                        await videoTrack.applyConstraints({torch: true});
                    }
                } else {
                    if(tracks.length) {
                        const videoTrack = tracks[0];
                        await videoTrack.applyConstraints({torch: false});
                    }
                }
                this.captures[id2].stream = stream
                video.srcObject = stream;
            } catch(e) {
                video.style.display = "none";
                this.displayError(e)
            }
            this.isLoading = false
        },
        PlaySound(soundObjId) {
          var sound = document.getElementById(soundObjId);
          sound.play();
        },
        stop() {
            this.scannerActive = false;
            Quagga.stop();
        },
        startScanner(id) {
            this.scannerActive = true
            $(".drawingBuffer").show();
            // let canvas = document.querySelector(`#${id}-barcode-canvas`);
            // let videoElement = document.querySelector(`#${id}-barcode-video`);
            let videoConstraints = {
                width: { min: 640, ideal: 1920, max: 4096 },
                height: { min: 480, ideal: 1080, max: 2400 },
                facingMode: 'environment', // or user
            }

            if(this.camera) {
                videoConstraints = {
                    width: 500,
                    height: 250,
                    facingMode: 'user', // or user
                }
            }
            Quagga.init(
                {
                    locate: true,
                  inputStream: {
                    name: 'Live',
                    type: 'LiveStream',
                    target: document.querySelector("#videoWindow"),
                    constraints: videoConstraints,
                    area: { // defines rectangle of the detection/localization area
                        top: "0%",    // top offset
                        right: "0%",  // right offset
                        left: "0%",   // left offset
                        bottom: "0%"  // bottom offset
                    },
                    singleChannel: false
                  },
                  decoder: {
                    readers: ['ean_reader', 'code_128_reader', 'code_39_reader'],
                    debug: {
                      drawBoundingBox: true,
                      drawScanline: true,
                      showPattern: true
                    },
                    multiple: false
                  },
                  locator: {
                    halfSample: true,
                    patchSize: "medium"
                  }
                },
                (err) => {
                  if (err) {
                    return;
                  }
                  Quagga.start();
                }
            );

            Quagga.onProcessed(function (result) {            
                var drawingCtx = Quagga.canvas.ctx.overlay, drawingCanvas = Quagga.canvas.dom.overlay;
                if (result) {
                  if (result.boxes) {
                    drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                    result.boxes.filter(function (box) {
                      return box !== result.box;
                    }).forEach(function (box) {
                      Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                    });
                  }

                  if (result.box) {
                    Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
                  }

                  if (result.codeResult && result.codeResult.code) {
                    Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
                  }
                }
            });

            Quagga.onDetected(this.handleBarcodeDetection);
        },
        async getCameraSelection() {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            const options = videoDevices.map(videoDevice => {
                return {
                    id: videoDevice.deviceId,
                    label: videoDevice.label
                }
            });
            this.camera_options = options
        },
        handleCameraSelection(id) {
            this.camera = id
        },
        handleBarcodeDetection(result) {
          if (result && result.codeResult && result.codeResult.code) {
            this.scannedCode = result.codeResult.code;
            Quagga.stop()
            this.scannerActive = false;
            this.PlaySound('sound1')
            // var cameraFeed = document.getElementById("cameraFeedContainer")
            // console.log(cameraFeed, "-------------")
            // cameraFeed.pause();
          }
        },
        beforeDestroy() {
            Quagga.offDetected(this.handleBarcodeDetection);
            // this.stop();
        },
        handleVehicleChange(id) {
            if(id) {
                let wasSelectedVehicleParked = this.dockWiseDockedInVehicleList.find(v => v.id == id && v.is_parked == 1)
                if(wasSelectedVehicleParked) {
                    this.was_vehicle_parked = true
                } else {
                    this.was_vehicle_parked = false
                }
                // let isSelectedVehicleOfBooking = this.dockWiseDockedInVehicleList.find(v => v.id == id && ['BOOKING', 'DELIVERY'].includes(v.field2))
                // if(isSelectedVehicleOfBooking) {
                //     this.dock_out_is_seal_optional = true
                // } else {
                //     if(!this.formData.dock_out.should_vehicle_be_parked) 
                //         this.dock_out_is_seal_optional = false
                // }
            } else {
                this.dock_out_is_seal_optional = false
                this.was_vehicle_parked = false
                this.formData.dock_out.should_vehicle_be_parked = false
            }
        },
        handleShouldVehicleBeParkedChange(id) {
            if(this.formData.dock_out.should_vehicle_be_parked) {
                this.dock_out_is_seal_optional = true
                this.formData.dock_out.seal_scan_no_0 = null
                this.formData.dock_out.seal_scan_no_1 = null
                this.formData.dock_out.seal_scan_no_2 = null
                this.formData.dock_out.seal_scan_no_3 = null
            } else {
                // let isSelectedVehicleOfBooking = this.dockWiseDockedInVehicleList.find(v => v.id == this.formData.dock_out.vehicle_id && ['BOOKING', 'DELIVERY'].includes(v.field2))
                // if(isSelectedVehicleOfBooking) {
                //     this.dock_out_is_seal_optional = true
                //     this.formData.dock_out.seal_scan_no_0 = null
                //     this.formData.dock_out.seal_scan_no_1 = null
                //     this.formData.dock_out.seal_scan_no_2 = null
                //     this.formData.dock_out.seal_scan_no_3 = null
                // } else {
                //     this.dock_out_is_seal_optional = false
                // }
                this.dock_out_is_seal_optional = false
            }
        },
        handleAwbChange(awb) {
            this.formData.pallet_scan.dock_id = null
            this.formData.pallet_scan.pallet_code = null
            if(awb) {
                let url = `/entry/unloading/pallet-scan/suggestions/${awb}`
                this.makeRequest('GET', url)
                .then(result => {
                    this.palletList = result.data.palletList
                    this.palletDockList = result.data.dockList
                    if(this.palletDockList?.length) {
                        this.formData.pallet_scan.dock_id = this.palletDockList[0].id
                    }
                    if(this.palletList?.length) {
                        this.formData.pallet_scan.pallet_code = this.palletList[0].id
                    }
                })
                .catch(e => {
                  this.displayError(e)
                })
            } else {
                this.palletList = []
                this.palletDockList = []
                this.formData.pallet_scan.dock_id = null
                this.formData.pallet_scan.pallet_code = null
            }
            
        },
        // movePallet(data) {
        //     console.log(data)
        //     this.isLoading = true
        //     let url = `/entry/unloading/pallet-movement/${data.gate_entry_id}/${data.pallet_code}/move`
        //     this.makeRequest("POST", url)
        //     .then(result => {
        //         // this.getPalletMovementList()
        //         this.sweetAlertSnackbar(result.data.message, 'success')
        //     })
        //     .catch(e => {
        //         this.displayError(e)
        //     })
        // },
        getPalletMovementList() {
            let url = `/entry/unloading/pallet-movement`
            this.makeRequest('GET', url)
            .then(result => {
                this.isLoading = false
                this.palletMovementList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getPalletScanInfo() {
            this.getVehiclesForPalletScan()
            // this.getAwbForPalletScan()
        },
        getVehiclesForPalletScan() {
            let url = `/entry/unloading/pallet-scan/vehicles`
            this.makeRequest('GET', url)
            .then(result => {
                this.palletScanVehicleList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getVehiclesForPalletUnloadScan() {
            let url = `/entry/loading/pallet-unload-scan/vehicles`
            this.makeRequest('GET', url)
            .then(result => {
                this.palletScanLoadVehicleList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getAwbForPalletScan() {
            let url = `/entry/unloading/pallet-scan/awb`
            this.makeRequest('GET', url)
            .then(result => {
                this.palletScanAwbList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getSealNumbersOfVehicle(vehicle) {
            if(vehicle?.is_parked) {
                this.dock_in_is_seal_optional = true
                return
            }
            this.dock_in_is_seal_optional = false
            this.isLoading = true
            let url = `/entry/dock-control/gate-vehicle-seal-numbers?vehicle_id=${vehicle.id}`
            let method = "GET"
            this.makeRequest(method, url)
                .then(result => {
                    this.isLoading = false
                    let sealData = result.data.data
                    if(sealData?.length) {
                        this.formData.dock_in.seal_scan_no = sealData[0].vehicle_seal_no
                    }
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        getSealBreakNumbersOfVehicle(vehicle) {
            this.isLoading = true
            let url = `/entry/dock-control/gate-vehicle-seal-numbers?vehicle_id=${vehicle.id}`
            let method = "GET"
            this.makeRequest(method, url)
                .then(result => {
                    this.isLoading = false
                    let sealData = result.data.data
                    if(sealData?.length) {
                        let list_seal = sealData[0].vehicle_seal_no.map(item => {
                            return {
                                id: item,
                                label: item
                            }
                        })
                        this.formData.seal_break.seal_scan_no = list_seal
                        this.formData.seal_break.seal_scan_no_value = sealData[0].vehicle_seal_no
                    }
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        resetform(tab) {
            if(tab === "dock_in") {
                this.formData.dock_in.dock_id = null
                this.formData.dock_in.vehicle_id = null
                this.formData.dock_in.seal_scan_no_0 = null
                this.formData.dock_in.seal_scan_no_1 = null
                this.formData.dock_in.seal_scan_no_2 = null
                this.formData.dock_in.seal_scan_no_3 = null
                this.formData.dock_in.seal_scan_no = []
            } else if(tab === "dock_out") {
                this.formData.dock_out.dock_id = null
                this.formData.dock_out.vehicle_id = null
                this.formData.dock_out.seal_scan_no_0 = null
                this.formData.dock_out.seal_scan_no_1 = null
                this.formData.dock_out.seal_scan_no_2 = null
                this.formData.dock_out.seal_scan_no_3 = null
                this.formData.dock_out.seal_scan_no = []
                this.formData.dock_out.should_vehicle_be_parked = false
            } else if(tab === "dock_vehicle_allocation") {
                this.formData.dock_vehicle_allocation.dock_id = null
                this.formData.dock_vehicle_allocation.vehicle_id = null
                this.formData.dock_vehicle_allocation.gate_entry_id = null
                // console.log(this.formData.dock_vehicle_allocation.expected_duration, 'before clear')
                if(this.formData.dock_vehicle_allocation.expected_duration) {
                    this.formData.dock_vehicle_allocation.expected_duration.HH = null
                    this.formData.dock_vehicle_allocation.expected_duration.mm = null
                }
                this.formData.dock_vehicle_allocation.expected_duration = null
                // console.log(this.formData.dock_vehicle_allocation.expected_duration, 'after clear')
            } else if(tab === "seal_break") {
                this.formData.seal_break.seal_scan_no = []
                this.formData.seal_break.dock_id = null
                this.formData.seal_break.vehicle_id = null
                this.formData.seal_break.seal_scan_no_value = null
                let canvases = document.getElementsByClassName("c")
                for (let element of canvases) {
                    element.style.display = "none"
                }
                    
                this.clearPhoto("seal_break-canvas")
            } else if(tab === "pallet_scan") {
                this.formData.pallet_scan.shipment_awb = null
                this.formData.pallet_scan.dock_id = null
                this.formData.pallet_scan.pallet_code = null
            }
        },
        validateForm(tab) {
            let isValid = true
            let formValues = this.formData[tab]
            if(tab === 'dock_vehicle_allocation') {
                if(!formValues.dock_id || !formValues.vehicle_id
                    || !formValues.expected_duration || (formValues.expected_duration && (!formValues.expected_duration.HH || !formValues.expected_duration.mm))
                ) {
                    isValid = false
                }
            } else if (tab === 'dock_in') {
                if(!formValues.dock_id || !formValues.vehicle_id) {
                    isValid = false
                }
                if(formValues.seal_scan_no?.length) {
                    for(let i=0; i<=formValues.seal_scan_no.length-1; i++) {
                        if(!formValues[`seal_scan_no_${i}`] || formValues[`seal_scan_no_${i}`] !== formValues.seal_scan_no[i]) {
                            isValid = false
                        }
                    }
                }
            } else if (tab === 'dock_out') {
                 if(!formValues.dock_id || !formValues.vehicle_id
                    || (this.dock_out_is_seal_optional && !formValues.seal_scan_no)
                ) {
                    isValid = false
                }
                if(!this.dock_out_is_seal_optional) {
                    for(let i=0; i<this.sealNumberCount; i++) {
                        let sealValue = formValues[`seal_scan_no_${i}`]
                        if(!sealValue) {
                            isValid = false
                        }
                    }
                }  
            } else if (tab === 'shipment_booking_master') {
                if(!formValues.shipment_awb || !formValues.booking_center_id || !formValues.shipment_actual_weight 
                    || !formValues.shipment_volumetric_weight || !formValues.shipment_dimensions
                    || !formValues.shipment_category || !formValues.shipment_subtype
                    || !formValues.charges || !formValues.tax
                    || !formValues.delivery_address || !formValues.delivery_city
                    || !formValues.delivery_pincode || !formValues.delivery_state
                    || !formValues.route_type
                ) {
                    isValid = false
                }
            } else if (tab === 'seal_break') {
                if(!formValues.vehicle_id || !formValues.dock_id || !this.captures[tab].file) {
                    isValid = false
                }
            } else if (tab === 'pallet_scan') {
                if(!formValues.dock_id || !formValues.vehicle_id || !formValues.pallet_code || !formValues.shipment_awb) {
                    isValid = false
                }
            } else {
                isValid = false
            }  
            return isValid
        },
        saveData(tab) {
            if(!this.validateForm(tab)) {
                this.sweetAlertSnackbar("Form was invalidated. Make sure that all reuired fields are filled out!", 'error')
                return
            }
            this.isLoading = true
            let payload = this.formData[tab]
            let method = "POST"
            let url = ""
            if(tab === "dock_vehicle_allocation") {
                url = `/master/docks/allocate-dock-to-vehicle`
            } else if(tab === "dock_in") {
                url = `/master/docks/dock-entry-scan`
            } else if(tab === "seal_break") {
                url = `/dock-control/seal-break`
            } else if(tab === "pallet_scan") {
                url = `/entry/unloading/pallet-scan/create`
            } else if(tab === "dock_out") {
                url = `/master/docks/dock-exit-scan`
                if(!this.dock_out_is_seal_optional) {
                    for(let i=0; i<this.sealNumberCount; i++) {
                        let sealValue = this.formData.dock_out[`seal_scan_no_${i}`]
                        payload.seal_scan_no.push(String(sealValue))
                    }
                } 
            }
            this.makeRequest(method, url, payload)
            .then(result => {
                this.isLoading = false
                if(result && result.data && result.data.status) {
                    this.resetform(tab)
                    this.getDockEntryDoneDockList()
                    if(tab === "dock_vehicle_allocation") {
                        this.getAllocationDoneDockList()
                        this.getAllocationDoneVehicleNumberList()
                    } else if(tab === "dock_in") {
                        this.getSealBreakDocks()
                        this.getSealBreakVehicles()
                        this.resetform("dock_vehicle_allocation")
                    } else if(tab === "dock_out") {
                        this.getAllocationDoneDockList()
                        this.getAllocationDoneVehicleNumberList()
                        this.getDockedInVehicleNumberList()
                        this.resetform("dock_in")
                        this.resetform("dock_vehicle_allocation")
                    } else if(tab === "seal_break") {
                        this.getSealBreakDocks()
                        this.getSealBreakVehicles()
                    } else if(tab === "pallet_scan") {
                        this.getPalletScanInfo()
                    }
                    this.getDockedInVehicleNumberList()
                    this.sweetAlertSnackbar(result.data.message, 'success')
                } else {
                    this.sweetAlertSnackbar(result.data.message, 'error')
                }
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        selectstatus() {},
        getAvailableDockList() {
            this.makeRequest("GET", "/master/docks/get-available-docks")
            .then(result => {
              this.available_dockList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getDockList() {
            this.searchNameMasterList('dock_master', 'dock_name', null, 'dock_id')
            .then(result => {
              this.dockList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getEntryPassDoneVehicleNumberList() {
            let url = `/master/vehicle_registrations/entry-pass-done-vehicles`
            this.makeRequest('GET', url)
            .then(result => {
                this.vehicleList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getAllocationDoneDockList() {
            let url = `/entry/dock-control/get-allocated-docs`
            this.makeRequest('GET', url)
            .then(result => {
                this.allocationDoneDockList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getAllocationDoneVehicleNumberList() {
            let url = `/master/vehicle_registrations/allocation-done-vehicles`
            this.makeRequest('GET', url)
            .then(result => {
                this.allocationDoneVehicleList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getSealBreakDocks() {
            let url = `/entry/dock-control/seal-break-docks`
            this.makeRequest('GET', url)
            .then(result => {
                this.sealBreakDockList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getSealBreakVehicles() {
            let url = `/entry/dock-control/seal-break-vehicles`
            this.makeRequest('GET', url)
            .then(result => {
                this.sealBreakVehicleList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getDockedInVehicleNumberList() {
            let url = `/master/vehicle_registrations/docked-in-vehicles`
            this.makeRequest('GET', url)
            .then(result => {
                this.dockedInVehicleList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        getDockEntryDoneDockList() {
            let url = `/exit/dock-control/dock-exit-docks`
            this.makeRequest('GET', url)
            .then(result => {
                this.dockEntryDoneDockList = result.data
            })
            .catch(e => {
              this.displayError(e)
            })
        },
        clearSealNumbers(id) {
            if(!this.formData.vehicle_id) {
                this.formData.dock_in.seal_scan_no = []
                this.formData.dock_in.seal_scan_no_0 = null
                this.formData.dock_in.seal_scan_no_1 = null
                this.formData.dock_in.seal_scan_no_2 = null
                this.formData.dock_in.seal_scan_no_3 = null
            }
        },
        handleDockInDockChange(id) {
            this.formData.dock_in.vehicle_id = null
            if(!id) {
                this.dockWiseAllocationDoneVehicleList = []
            } else {
                this.dockWiseAllocationDoneVehicleList = this.allocationDoneVehicleList.filter(vehicle => vehicle.field == id)
            }
        },
        handleSealBreakDockChange(id) {
            this.formData.seal_break.vehicle_id = null
            if(!id) {
                this.sealBreakVehicleListDockWise = []
            } else {
                this.sealBreakVehicleListDockWise = this.sealBreakVehicleList.filter(vehicle => vehicle.dock_id == id)
            }
        },
        handleDockOutDockChange(id) {
            this.formData.dock_out.vehicle_id = null
            if(!id) {
                this.dockWiseDockedInVehicleList = []
            } else {
                this.dockWiseDockedInVehicleList = this.dockedInVehicleList.filter(vehicle => vehicle.field == id)
            }
        },
        clearPhoto(id) {
            let canvas = document.querySelector(`#${id}`);
            canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
        },
    }
})
</script>
<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
.requiredField {
    margin-left: 2px;
    color: red
}

#v {
    position: absolute;
    top: 0%;
    left: 0%;
    margin: auto;
}

#c {
    display: none
}
.c {
    display: none;
    object-fit: cover;
}

#overlay-camera {
  position: fixed;
  display: none;
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,1);
  z-index: 2; 
  cursor: pointer;
}

.overlay-camera {
  position: fixed;
  display: none;
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,1);
  z-index: 2; 
  cursor: pointer;
}

.fill-green2 {

    fill: #D9D9D9
}
</style>